import {
  expiresAfter,
  getCookie,
  injectIntoDataLayer,
  setCookie,
  encryptData,
  getUniqueSessionId,
  networkCall,
  fetchGAClientId,
  handleSignupLoggingAndSessionStorage,
  clearNecessaryLS,
  getCountryConsolidated
} from '../../../utils/library';
import {
  CLEAR_STORE,
  IS_USER_AUTHENTICATED,
  IS_USER_AUTHENTICATING,
  LOAD_USER_SESSION,
  SET_IS_EU_REGION_MOBILE_VERIFIED,
  SET_IS_NEW_USER,
  SET_CSRF_TOKEN,
  NON_HARD_MIGRATED_SME_FLOW,
  SET_INSTAPOINTS_BALANCE,
  UPDATE_USER_TIER
} from '../../action-contants';
import {
  INDIVIDUAL,
  INITIATED,
  POST_LOGOUT,
  REGISTERED,
  CONTENTFUL_SCHEMA_KEYS,
  CORPORATE,
  UTM_CAMPAIGNING,
  EKYC_RETRY_COUNT,
  IN,
  UPSELLING_MODAL_SESSION_KEY,
  NF_IS_VKYC_MODAL_CLOSED,
  IP_MODAL_OPEN,
  SESSION_STORAGE_IS_SIGNUP_API
} from '../../../utils/constants';
import { handleError, showMessage } from '../common-message/message-action';
import { API_URL, REQ_TIMEOUT, API_URL_V2 } from '../../../utils/config';
import {
  remitterPersonalInfo,
  setNonHardMigratedSMEFlag,
  toggleIsUtilityApiCalledAction
} from '../user-status/user-status-action';
import {
  getSourceCurrencies,
  makeApiCall,
  getContentSchemaFromContentFul
} from '../common/common-action';
import { activateLoader, disableLoader } from '../ui-trigger/ui-trigger-action';
import get from 'lodash/get';
import { store } from '../../../store';
import isEmpty from 'lodash/isEmpty';
import toLower from 'lodash/toLower';
import { SIGNIN, FLOW_TYPE_LOGIN } from '../../../utils/constants/eventsConstants';
import { getNiumForexUserDetails, storeNiumForexUser } from '../nium-forex/nium-forex-action';
import { pushGeoLocationDataToCT, updateUserProperties } from '../../../utils/events/cleverTap';
import { getFlagValue, isFlagEnabled } from '../flagsmith/flagsmith-main';
import { resetStatsigUser } from '../../../utils/statsig';
import { logEvent } from '../../../utils/events/logUserEvents';
import { LOG_TYPE } from '../../../utils/events/eventsConstants';
import { startCase } from 'lodash';

export function isUserAuthenticatingDispatch(data) {
  return (dispatch) => {
    //update the screens
    dispatch(isUserAuthenticating(data));
  };
}

export function isUserAuthenticatedDispatch(data) {
  return (dispatch) => {
    //update the screens
    dispatch(isUserAuthenticated(data));
  };
}

export function clearStore(state) {
  return {
    type: CLEAR_STORE,
    state
  };
}

export function isUserAuthenticating(data) {
  return {
    type: IS_USER_AUTHENTICATING,
    data
  };
}

export function isUserAuthenticated(data) {
  return {
    type: IS_USER_AUTHENTICATED,
    data
  };
}

export function setIsNewuser(data) {
  return (dispatch) => {
    dispatch({
      type: SET_IS_NEW_USER,
      data
    });
  };
}

export function setInstaPointBalance(data) {
  return (dispatch) => {
    dispatch({
      type: SET_INSTAPOINTS_BALANCE,
      data
    });
  };
}

export function setIsEuRegion(data) {
  return (dispatch) => {
    dispatch({
      type: SET_IS_EU_REGION_MOBILE_VERIFIED,
      data
    });
  };
}

export function loadUserSession(data) {
  return {
    type: LOAD_USER_SESSION,
    data
  };
}

export function updateUserTier(data) {
  return {
    type: UPDATE_USER_TIER,
    data
  };
}
export function newSignUpRequest(props, dataLayerObj) {
  return async (dispatch) => {
    try {
      let reqData = { ...props, session_id: getUniqueSessionId() };
      reqData.password = encryptData(reqData.password);
      let utmCookie = getCookie('utm');
      if (utmCookie) utmCookie = JSON.parse(utmCookie);
      else utmCookie = {};

      let utmCampaigningCookie = getCookie(UTM_CAMPAIGNING);
      const clickref = getCookie('clickref');
      if (utmCampaigningCookie) utmCampaigningCookie = JSON.parse(utmCampaigningCookie);
      else utmCampaigningCookie = {};

      let params = {
        method: 'post',
        url: `${API_URL_V2}/signup`,
        withCredentials: true,
        data: clickref ? { ...reqData, ...utmCookie, clickref } : { ...reqData, ...utmCookie },
        headers: {
          'ga-client-id': fetchGAClientId()
        }
      };

      let response = await networkCall(params, dispatch, reqData, dataLayerObj);

      if (!response) return { message: 'no response' };
      if (response && response.data && response.data.success) {
        clearNecessaryLS();
        if (response.data.data && response.data.data.error) {
          dispatch(
            showMessage({
              text: response.data.data.errorMessage,
              type: 'success'
            })
          );
          response.data.success = false;
          dispatch(isUserAuthenticating(false));
          dispatch(isUserAuthenticated(false));
          return response;
        } else {
          const { emailVerificationRequired = false } = response.data.data;
          if (!emailVerificationRequired) {
            const {
              customer_id,
              account_type,
              auth_type,
              email,
              user_id,
              country_code,
              csrf_token,
              remitter_id
            } = response.data.data.user || {};

            const { referred_by_referral_code, is_term_conditions_accepted, device_id } = props;
            handleSignupLoggingAndSessionStorage(
              customer_id,
              auth_type,
              email,
              user_id,
              utmCampaigningCookie,
              is_term_conditions_accepted,
              account_type,
              country_code,
              referred_by_referral_code,
              csrf_token,
              dispatch,
              remitter_id,
              device_id
            );
          }
        }
      }
      return { ...response, utmCampaigningCookie };
    } catch (err) {
      dispatch(isUserAuthenticating(false));
      dispatch(disableLoader());
      if (err?.response?.status === 429) {
        dispatch(
          showMessage({
            text: [`Hold up! You have hit the limit. Please try again later.`],
            type: 'info'
          })
        );
      } else dispatch(handleError(err));
      dispatch(isUserAuthenticated(false));
      let { response } = err;
      return response || err;
    }
  };
}

export function logInRequest(postdata) {
  return async (dispatch) => {
    try {
      let reqData = { ...postdata };
      reqData.password = encryptData(reqData.password);
      let params = {
        method: 'post',
        url: `${API_URL_V2}/login`,
        data: reqData
      };
      let response = await networkCall(params, dispatch, {}, { formID: 'form-sign-in' });
      if (!response) return { message: 'no response' };
      if (response && response.data && response.data.success) {
        const { email, user_id, account_type, customer_id, auth_type, country_code, remitter_id } =
          response.data.data;
        const loginMethod = toLower(auth_type) || 'Email';
        const logObject = {
          cin: customer_id,
          log_in_method: loginMethod,
          Email: email
        };

        const defaultData = {
          custom: {
            loginMethod: auth_type ? startCase(toLower(auth_type)) : 'Email',
            Email: email?.toLowerCase(),
            CIN: customer_id,
            accountType: startCase(toLower(account_type)),
            Identity: remitter_id,
            countryConsolidated: getCountryConsolidated(country_code)
          }
        };
        logEvent(
          SIGNIN,
          FLOW_TYPE_LOGIN,
          {
            logInMethod: loginMethod,
            ...defaultData.custom
          },
          LOG_TYPE.CLEVER_TAP,
          true,
          { ...defaultData.custom }
        );
        logEvent(
          SIGNIN,
          FLOW_TYPE_LOGIN,
          {
            ...logObject,
            remitter_country: country_code,
            user_id
          },
          LOG_TYPE.GA
        );
        pushGeoLocationDataToCT();
        localStorage.setItem('eKYCRetryCount', EKYC_RETRY_COUNT);
        sessionStorage.setItem(IP_MODAL_OPEN, true);
        sessionStorage.removeItem(UPSELLING_MODAL_SESSION_KEY);
        clearNecessaryLS();
        dispatch(setCsrfToken(response.data.data.csrf_token));
        if (response.data.data.twoFA) {
          await dispatch(
            setIsEuRegion({
              twoFactorToken: response.data.data.twoFA,
              twoFactorTokenKey: response.data.data.twoFAToken
            })
          );

          dispatch(isUserAuthenticating(false));
          dispatch(isUserAuthenticated(false));
          return response;
        } else if (
          response.data.data?.is_internal === false &&
          !response.data.data?.partner_permission_granted
        ) {
          dispatch(isUserAuthenticating(false));
          dispatch(isUserAuthenticated(false));
          return response;
        } else {
          return dispatch(authenticateUser(false, 'sign-in'));
        }
      }
    } catch (err) {
      dispatch(isUserAuthenticating(false));
      dispatch(handleError(err, false, true));
      dispatch(isUserAuthenticated(false));
      let { response } = err;
      return response || err;
    }
  };
}

export function socialSignUpReq(data, provider) {
  return async (dispatch) => {
    try {
      let utmCookie = getCookie('utm');
      if (utmCookie) utmCookie = JSON.parse(utmCookie);
      else utmCookie = {};

      let utmCampaigningCookie = getCookie(UTM_CAMPAIGNING);
      const clickref = getCookie('clickref');
      if (utmCampaigningCookie) utmCampaigningCookie = JSON.parse(utmCampaigningCookie);
      else utmCampaigningCookie = {};

      const reqData = { ...data, ...utmCookie, session_id: getUniqueSessionId() };

      let response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/signup/${provider}`,
        withCredentials: true,
        data: clickref ? { ...reqData, clickref } : reqData,
        timeout: REQ_TIMEOUT,
        headers: {
          'ga-client-id': fetchGAClientId()
        }
      });
      if (!response) return { message: 'no response' };
      if (response && response.data && response.data.success) {
        if (response.data.data && response.data.data.error) {
          dispatch(
            showMessage({
              text: response.data.data.errorMessage,
              type: 'success'
            })
          );
          response.data.success = false;
        } else {
          const { emailVerificationRequired = false } = response.data.data;
          if (!emailVerificationRequired) {
            const {
              customer_id,
              account_type,
              auth_type,
              email,
              user_id,
              country_code,
              remitter_id,
              csrf_token
            } = response.data.data.user || {};
            updateUserProperties({ Email: email?.toLowerCase() });
            const { referred_by_referral_code, is_term_conditions_accepted, device_id } = data;
            handleSignupLoggingAndSessionStorage(
              customer_id,
              auth_type,
              email,
              user_id,
              utmCampaigningCookie,
              is_term_conditions_accepted,
              account_type,
              country_code,
              referred_by_referral_code,
              csrf_token,
              dispatch,
              remitter_id,
              device_id
            );
            dispatch(authenticateUser(false, `social-sign-up-${provider}`));
          }
        }
        return { ...response, utmCampaigningCookie };
      }
      dispatch(isUserAuthenticating(false));
      dispatch(isUserAuthenticated(false));
      return response;
    } catch (err) {
      dispatch(isUserAuthenticating(false));
      dispatch(handleError(err));
      dispatch(isUserAuthenticated(false));
      return err;
    } finally {
      sessionStorage.removeItem(SESSION_STORAGE_IS_SIGNUP_API);
    }
  };
}

export function socialSignInReq(postdata, provider) {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'post',
        url: `${API_URL_V2}/login/${provider}`,
        withCredentials: true,
        data: postdata,
        timeout: REQ_TIMEOUT
      });
      if (!response) return { message: 'no response' };
      if (response && response.data && response.data.success) {
        if (response.data.data && response.data.data.error) {
          dispatch(
            showMessage({
              text: response.data.data.errorMessage,
              type: 'success'
            })
          );
          response.data.success = false;
        } else {
          const {
            email,
            user_id,
            account_type,
            customer_id,
            auth_type,
            country_code,
            remitter_id
          } = response.data.data;
          const loginMethod =
            auth_type === 'GOOGLE_PLUS' ? 'google' : toLower(auth_type) || 'Email';
          const logObject = {
            cin: customer_id,
            log_in_method: loginMethod,
            email
          };
          const defaultData = {
            custom: {
              customerId: customer_id,
              Email: email,
              pageName: 'signin',
              userId: user_id,
              accountType: account_type,
              remitterCountry: country_code,
              platform: 'Web'
            }
          };
          logEvent(
            SIGNIN,
            FLOW_TYPE_LOGIN,
            {
              log_in_method: loginMethod,
              ...defaultData.custom
            },
            LOG_TYPE.CLEVER_TAP,
            true,
            {
              Identity: remitter_id,
              ...defaultData.custom
            }
          );
          logEvent(
            SIGNIN,
            FLOW_TYPE_LOGIN,
            {
              ...logObject,
              remitter_country: country_code,
              user_id
            },
            LOG_TYPE.GA
          );
          pushGeoLocationDataToCT();
          localStorage.setItem('eKYCRetryCount', EKYC_RETRY_COUNT);
          sessionStorage.setItem(IP_MODAL_OPEN, true);
          dispatch(setCsrfToken(response.data.data.csrf_token));
          let { twoFA, twoFAToken } = response.data.data;
          if (twoFA) {
            await dispatch(
              setIsEuRegion({
                twoFactorToken: twoFA,
                twoFactorTokenKey: twoFAToken
              })
            );
          } else if (
            response.data.data?.is_internal === false &&
            !response.data.data?.partner_permission_granted
          ) {
            dispatch(isUserAuthenticating(false));
            dispatch(isUserAuthenticated(false));
            return response;
          } else {
            dispatch(authenticateUser(false, `social-sign-in-${provider}`));
          }
        }
        return response;
      }
      dispatch(isUserAuthenticating(false));
      dispatch(isUserAuthenticated(false));
      return response;
    } catch (err) {
      dispatch(isUserAuthenticating(false));
      dispatch(handleError(err));
      dispatch(isUserAuthenticated(false));
      return err;
    } finally {
      sessionStorage.removeItem(SESSION_STORAGE_IS_SIGNUP_API);
    }
  };
}

export function getResetPasswordLink(props) {
  return async (dispatch) => {
    try {
      return await makeApiCall({
        url: `${API_URL}/password/reset-link`,
        method: 'post',
        withCredentials: true,
        data: props,
        timeout: REQ_TIMEOUT
      });
    } catch (err) {
      dispatch(disableLoader());
      dispatch(handleError(err));
      let { response } = err;
      return response || err;
    }
  };
}

export function resetPasswordRequest({ email, password }) {
  return async (dispatch) => {
    try {
      password = encryptData(password);
      return await makeApiCall({
        method: 'post',
        url: `${API_URL}/password/reset`,
        withCredentials: true,
        data: {
          email,
          password,
          session_id: getUniqueSessionId(),
          reset_link: window.location.href
        },
        timeout: REQ_TIMEOUT
      });
    } catch (err) {
      dispatch(handleError(err, false));
      let { response } = err;
      return response || err;
    }
  };
}

export const performLogoutCleanup = (dispatch) => {
  localStorage.removeItem('eKYCRetryCount');
  const { sessionStorage } = window;
  dispatch(toggleIsUtilityApiCalledAction(false));
  dispatch(isUserAuthenticated(false));
  document.cookie = 'InstaremSession=;expires=Thu, 01 Jan 1970 00:00:01 GMT; secure;';
  dispatch(clearStore());
  injectIntoDataLayer('logout', { epoch: Date.now() });
  sessionStorage.removeItem(UPSELLING_MODAL_SESSION_KEY);
  sessionStorage.removeItem(NF_IS_VKYC_MODAL_CLOSED);
  sessionStorage.removeItem(IP_MODAL_OPEN);
  clearNecessaryLS();
  resetStatsigUser();
};

export function logoutRequest() {
  return async (dispatch, getState) => {
    try {
      const { account_type, country_code, referral_code } =
        getState().rootReducer.userSessionReducer.user_session;
      if (account_type === INDIVIDUAL) {
        dispatch(activateLoader());
        await storePostLogoutData(country_code, referral_code);
      }
      let response = await makeApiCall({
        url: `${API_URL}/logout`,
        method: 'get',
        withCredentials: true,
        timeout: REQ_TIMEOUT
      });
      if (!response) {
        localStorage.removeItem(POST_LOGOUT);
        dispatch(disableLoader());
        return { message: 'no response' };
      }
      if (response && response.data && response.data.success) {
        performLogoutCleanup(dispatch);
      }
      return response;
    } catch (err) {
      localStorage.removeItem(POST_LOGOUT);
      dispatch(disableLoader());
      dispatch(handleError(err));
      let { response } = err;
      return response || err;
    }
  };
}

export function authenticateUser(
  is_message_disabled,
  source,
  status_refresh_required,
  referred_by_referral_code
) {
  return async (dispatch) => {
    try {
      await dispatch(isUserAuthenticating(true));
      let response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/user`,
        withCredentials: true,
        headers: {
          'Cache-Control': 'no-store, no-cache, must-revalidate, post-check=0, pre-check=0',
          Pragma: 'no-cache',
          Expires: new Date().toUTCString()
        }
      });
      if (response && response.data && response.data.data && response.data.success) {
        const countryCode = response.data.data.country_code;
        const accountType = response.data.data.account_type;
        if (countryCode === IN && accountType === INDIVIDUAL) {
          dispatch(storeNiumForexUser(true));
          dispatch(getNiumForexUserDetails());
        }
        if (accountType === CORPORATE) {
          const nonHardMigratedSMEFlag = {
            isFeatureEnabled: isFlagEnabled(NON_HARD_MIGRATED_SME_FLOW),
            data: getFlagValue(NON_HARD_MIGRATED_SME_FLOW)
          };
          dispatch(setNonHardMigratedSMEFlag(nonHardMigratedSMEFlag));
        }

        if (!status_refresh_required) {
          await dispatch(
            remitterPersonalInfo({
              customerId: response.data.data.customer_id,
              isAmazeUser: response.data.data.is_amaze_customer
            })
          );
        }
        let user_session = response.data.data;
        updateUserProperties({
          Identity: user_session.remitter_id,
          Email: user_session.email?.toLowerCase(),
          CIN: user_session.customer_id,
          accountType: startCase(toLower(user_session.account_type)),
          countryConsolidated: getCountryConsolidated(user_session.country_code)
        });
        if (user_session.csrf_token) {
          dispatch(setCsrfToken(user_session.csrf_token));
        }
        if ([INITIATED, REGISTERED].includes(user_session.user_status))
          user_session.is_new_user = true;
        if (source === 'sign-up') {
          user_session.isUserRecentlySignedUp = true;
          if (referred_by_referral_code) user_session.isReferralCodeSubmittedOnSignup = true;
        }
        await dispatch(loadUserSession(user_session));
        if (source) injectIntoDataLayer(source, response.data.data);
        else {
          let external = getCookie('external-sign-up');
          if (external) {
            injectIntoDataLayer('sign-up', response.data.data);
            setCookie('external-sign-up', null, expiresAfter(-1));
          }
        }
        if (status_refresh_required) {
          dispatch(isUserAuthenticated(true));
          dispatch(isUserAuthenticating(false));
        }
        let { country_code } = response.data.data,
          { sessionStorage } = window;
        sessionStorage && sessionStorage.setItem('CLIENT_COUNTRY_CODE', country_code);
      } else {
        await dispatch(isUserAuthenticating(false));
        await dispatch(isUserAuthenticated(false));
      }
      return response;
    } catch (error) {
      await dispatch(isUserAuthenticating(false));
      await dispatch(isUserAuthenticated(false));
      await dispatch(handleError(error, is_message_disabled));
    }
  };
}

export function setCsrfToken(data) {
  return {
    type: SET_CSRF_TOKEN,
    data
  };
}

const storePostLogoutData = async (country_code, referral_code) => {
  const reduxStore = store.getState();
  const instapoint_balance = get(
    reduxStore,
    'rootReducer.userSessionReducer.instapoint_balance',
    false
  );
  const is_amaze_user = get(
    reduxStore,
    'rootReducer.userSessionReducer.user_session.is_amaze_customer',
    false
  );
  const is_remittance_user = get(
    reduxStore,
    'rootReducer.userSessionReducer.user_session.is_remittance_transaction_initiated',
    false
  );
  const currencyResponce = await getSourceCurrencies(country_code);
  if (currencyResponce?.data?.success) {
    const source_currencies = currencyResponce.data.data;
    const { redemption_value, transaction_referral_instapoint, initial_referral_instapoint } =
      instapoint_balance;
    let referralScreenSchema = await getContentSchemaFromContentFul(
      CONTENTFUL_SCHEMA_KEYS['REFER_N_EARN']['CONTENT_TYPE'],
      CONTENTFUL_SCHEMA_KEYS['REFER_N_EARN']['TITLE']
    );
    if (isEmpty(referralScreenSchema)) {
      referralScreenSchema = null;
    }
    const payload = {
      country_code,
      redemption_value,
      source_currencies,
      referral_code,
      transaction_referral_instapoint,
      referralScreenSchema,
      initial_referral_instapoint,
      is_amaze_user,
      is_remittance_user
    };
    localStorage.setItem(POST_LOGOUT, JSON.stringify(payload));
  }
};

export function authorizePartner(data) {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'post',
        url: `${API_URL_V2}/partner/authorize`,
        withCredentials: true,
        data
      });
      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function getUserInfo() {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/user`,
        withCredentials: true
      });
      if (response?.data?.success) {
        await dispatch(updateUserTier({ tier: response?.data?.data?.tier }));
      }
      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}
